import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/cloudflare/landing_regions";

const fetchListData = async () => {
  const response = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  const data = response.data?.["hydra:member"] ?? [];
  const total = response.data?.["hydra:totalItems"] ?? 0;

  return {
    data,
    total,
  };
};

export const landingRegionsSchema: DataProviderSchema<
  "LandingRegion",
  "jsonld"
> = {
  list: fetchListData,
};
